import {
  GetValidationErrorsExportAvailabilityDocument,
  type ValidationErrorsSourceExportUnavailableReason,
} from '@/lib/graphql/generated/graphql';
import { useQuery } from '@apollo/client/react';

/**
 * Export à proposer dans le panneau d'anomalies :
 * - `loading` : la disponibilité n'est pas encore connue ;
 * - `source` : le fichier d'origine avec les colonnes d'erreurs (AUTO-1762) ;
 * - `so` : l'export de la phase 1, avec la raison quand l'API l'a donnée.
 *   Une erreur de la requête (API qui ne connaît pas encore le champ, réseau)
 *   donne `so` sans raison : l'export de la phase 1 reste toujours possible.
 */
export type ValidationErrorsExportChoice =
  | { status: 'loading' }
  | { status: 'source' }
  | {
      status: 'so';
      reason: ValidationErrorsSourceExportUnavailableReason | null;
    };

export function useValidationErrorsExportAvailability(
  dealId: string
): ValidationErrorsExportChoice {
  const { data, loading, error } = useQuery(
    GetValidationErrorsExportAvailabilityDocument,
    {
      variables: { dealId },
      skip: !dealId,
      // Relue à chaque ouverture du panneau : un import ou une validation a pu
      // changer la réponse depuis.
      fetchPolicy: 'network-only',
    }
  );

  if (error) return { status: 'so', reason: null };
  const availability = data?.validationErrorsExportAvailability;
  if (!availability) {
    return loading ? { status: 'loading' } : { status: 'so', reason: null };
  }
  return availability.sourceExport
    ? { status: 'source' }
    : { status: 'so', reason: availability.reason ?? null };
}
